import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { apiFetch } from '../utils/api';

const DashboardContext = createContext(undefined);

export const useDashboard = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard must be used within DashboardProvider');
  return ctx;
};

export function DashboardProvider({ children }) {
  const { token } = useAuth();
  const [dates, setDates] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;

    let cancelled = false;
    setLoading(true);

    apiFetch('/config', token)
      .then((data) => {
        if (cancelled) return;
        setDates(data.dates);
        setTeams(data.teams);
        const defaultDate = data.dates.includes('2026-01-01') ? '2026-01-01' : data.dates[data.dates.length - 1];
        if (data.dates.length > 0) setSelectedDate(defaultDate);
        const defaultTeam = data.teams.includes('Liverpool') ? 'Liverpool' : data.teams[0];
        if (data.teams.length > 0) setSelectedTeam(defaultTeam);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [token]);

  const selectTeam = useCallback((team) => setSelectedTeam(team), []);
  const selectDate = useCallback((date) => setSelectedDate(date), []);
  const modelDatesParam = dates.length > 0 ? dates.join(',') : '';

  return (
    <DashboardContext.Provider value={{
      dates, teams, selectedDate, selectedTeam,
      selectTeam, selectDate, loading, error, modelDatesParam,
    }}>
      {children}
    </DashboardContext.Provider>
  );
}
